/**
 * Getting Started - Goals Selection Component
 * Alpine.js component for the "What brings you here?" step
 */

/**
 * Goals selection component factory
 * Handles checkbox selection with visual feedback and romance confirmation
 */
export function gettingStartedGoals(initialSelected = []) {
    return {
        // State
        selected: initialSelected,
        showConfirmation: false,
        confirmedRomance: false,

        // Color mapping for each goal
        colors: {
            friend: {
                bg: 'bg-violet-500',
                bgLight: 'bg-violet-50',
                text: 'text-violet-600',
                textSelected: 'text-violet-700'
            },
            langex: {
                bg: 'bg-emerald-500',
                bgLight: 'bg-emerald-50',
                text: 'text-emerald-600',
                textSelected: 'text-emerald-700'
            },
            meet: {
                bg: 'bg-amber-500',
                bgLight: 'bg-amber-50',
                text: 'text-amber-600',
                textSelected: 'text-amber-700'
            },
            snail: {
                bg: 'bg-sky-500',
                bgLight: 'bg-sky-50',
                text: 'text-sky-600',
                textSelected: 'text-sky-700'
            },
            relation: {
                bg: 'bg-rose-500',
                bgLight: 'bg-rose-50',
                text: 'text-rose-600',
                textSelected: 'text-rose-700'
            }
        },

        // Methods
        toggle(value) {
            const index = this.selected.indexOf(value);
            if (index === -1) {
                this.selected.push(value);
            } else {
                this.selected.splice(index, 1);
            }
        },

        isSelected(value) {
            return this.selected.includes(value);
        },

        getIconClasses(value) {
            const color = this.colors[value];
            if (this.isSelected(value)) {
                return `${color.bg} text-white shadow-lg scale-110`;
            }
            return `${color.bgLight} ${color.text}`;
        },

        getLabelClasses(value) {
            const color = this.colors[value];
            if (this.isSelected(value)) {
                return color.textSelected;
            }
            return 'text-gray-600';
        },

        handleSubmit() {
            if (this.selected.length === 0) {
                alert(window.t('common.getting_started.select_at_least_one'));
                return false;
            }

            // Check if romance is selected and confirmation not shown
            if (this.selected.includes('relation') && !this.confirmedRomance) {
                this.showConfirmation = true;
                return false;
            }

            return true;
        },

        goBack() {
            this.showConfirmation = false;
        },

        confirmAndSubmit() {
            this.confirmedRomance = true;
            this.$refs.form.submit();
        }
    };
}
